/**
 * @Author: hedongyang
 * @Date: 2024-02-04
 * @Description: 菲律宾Tagalog
 */
export default {
  name: 'ph',
  fs: {
    component: {
      select: {
        placeholder: 'Pakipili'
      }
    },
    addForm: { title: 'Add' },
    editForm: { title: 'Edit' },
    viewForm: { title: 'View' },
    rowHandle: {
      title: 'Operasyon',
      remove: {
        text: 'tanggalin',
        confirmTitle: 'Tanggalin ang prompt',
        confirmMessage: 'Sigurado ka bang gusto mong tanggalin ang talang ito?',
        success: 'Matagumpay na tanggalin!'
      },
      edit: {
        text: 'edit'
      },
      view: {
        text: 'Tingnan'
      }
    },
    form: {
      cancel: 'kanselahin',
      ok: 'OK'
    },
    actionbar: { add: 'Add' },
    toolbar: {
      columnFilter: {
        title: 'Mga setting ng column',
        fixed: 'fixed',
        order: 'uriin',
        reset: 'ibalik',
        confirm: 'OK',
        unnamed: 'walang pangalan'
      },
      search: { title: 'Query display' },
      refresh: { title: 'I-refresh' },
      compact: { title: 'Compact mode' },
      export: { title: 'I-export' },
      columns: { title: 'Column settings' }
    },
    search: {
      container: {
        collapseButton: {
          text: {
            collapse: 'collapse',
            expand: 'palawakin'
          }
        }
      },
      search: { text: 'query' },
      reset: { text: 'I-reset' },
      error: {
        message: 'Nabigo ang pag-verify ng form ng query'
      }
    },
    pagination: {
      showTotal: 'Kabuuang {0} mga item'
    },
    date: {
      formatter: { to: 'to' }
    },
    extends: {
      cropper: {
        reChoose: 'Muling piliin',
        flipX: 'I-flip pataas at pababa',
        flipY: 'I-flip pakaliwa at pakanan',
        reset: 'i-reset'
      },
      fileUploader: {
        text: 'Pag-upload ng file',
        limitTip: 'Ang bilang ng mga file ay hindi maaaring lumampas sa {0}',
        sizeLimitTip:
          'Ang laki ng file ay hindi maaaring lumampas sa {0}, kasalukuyang laki: {1}',
        hasUploading:
          'Mayroon pa ring mga file na ina-upload, mangyaring maghintay para makumpleto ang pag-upload, o tanggalin ito'
      }
    }
  }
};
